import IstModal from "./IstModal.vue";
import IstLayoutCard from "./IstLayoutCard.vue";
import IstFormSelect from "./IstFormSelect.vue";
import IstFormSearch from "./IstFormSearch.vue";
import IstFormTime from "./IstFormTime.vue";
import IstNumberInput from "./IstNumberInput.vue";
import IstToolbarDate from "./IstToolbarDate.vue";
import IstToolbarWeek from "./IstToolbarWeek.vue";
import IstFormInput from "./IstFormInput.vue";
import DatePickerWithHolidays from "./DatePickerWithHolidays.vue";
import IstAvatar from "./IstAvatar.vue";
import IstChipSelect from "./IstChipSelect.vue";
import IstMultipleSelect from "./IstMultipleSelect.vue";
import dtpBadge from "./dtpBadge.vue";
import dtpBanner from "./dtpBanner.vue";
import dtpBtn from "./dtpBtn.vue";
import dtpButtonDropdown from "./dtpButtonDropdown.vue";
import dtpCard from "./dtpCard.vue";
import dtpCardActions from "./dtpCardActions.vue";
import dtpCardSection from "./dtpCardSection.vue";
import dtpCheckbox from "./dtpCheckbox.vue";
import dtpChip from "./dtpChip.vue";
import dtpIcon from "./dtpIcon.vue";
import dtpItem from "./dtpItem.vue";
import dtpItemLabel from "./dtpItemLabel.vue";
import dtpItemSection from "./dtpItemSection.vue";
import dtpList from "./dtpList.vue";
import dtpRadio from "./dtpRadio.vue";
import dtpSplitter from "./dtpSplitter.vue";
import dtpToggle from "./dtpToggle.vue";
import dtpToolbar from "./dtpToolbar.vue";
import dtpFormSearch from "./dtpFormSearch.vue";

export default {
  install(Vue) {
    Vue.component("ISTModal", IstModal);
    Vue.component("ISTLayoutCard", IstLayoutCard);
    Vue.component("ISTFormSelect", IstFormSelect);
    Vue.component("ISTFormSearch", IstFormSearch);
    Vue.component("ISTFormTime", IstFormTime);
    Vue.component("ISTNumberInput", IstNumberInput);
    Vue.component("ISTToolbarDate", IstToolbarDate);
    Vue.component("ISTToolbarWeek", IstToolbarWeek);
    Vue.component("ISTFormInput", IstFormInput);
    Vue.component("ISTDatePicker", DatePickerWithHolidays);
    Vue.component("ISTAvatar", IstAvatar);
    Vue.component("ISTChipSelect", IstChipSelect);
    Vue.component("ISTMultipleSelect", IstMultipleSelect);
    Vue.component("dtpBadge", dtpBadge);
    Vue.component("dtpBanner", dtpBanner);
    Vue.component("dtpBtn", dtpBtn);
    Vue.component("dtpButtonDropdown", dtpButtonDropdown);
    Vue.component("dtpCard", dtpCard);
    Vue.component("dtpCardActions", dtpCardActions);
    Vue.component("dtpCardSection", dtpCardSection);
    Vue.component("dtpCheckbox", dtpCheckbox);
    Vue.component("dtpChip", dtpChip);
    Vue.component("dtpIcon", dtpIcon);
    Vue.component("dtpItem", dtpItem);
    Vue.component("dtpItemLabel", dtpItemLabel);
    Vue.component("dtpItemSection", dtpItemSection);
    Vue.component("dtpList", dtpList);
    Vue.component("dtpRadio", dtpRadio);
    Vue.component("dtpSplitter", dtpSplitter);
    Vue.component("dtpToggle", dtpToggle);
    Vue.component("dtpToolbar", dtpToolbar);
    Vue.component("dtpFormSearch", dtpFormSearch);
  }
};
